import { Group, Loader, Text } from '@mantine/core';
import { IconCircleFilled } from '@tabler/icons-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ResultsSummary } from '../../data-access/types/results';
import {
  GES_STATUS_STAT_ORDER,
  getGesStatusCount,
} from '../../lib/results-stats';
import { getGesStatusMeta } from '../../utils/ges-status';

import classes from './results-header.module.css';

export interface ResultsStatsHeaderProps {
  summary: ResultsSummary | undefined;
  isLoading?: boolean;
}

export const ResultsStatsHeader: FC<ResultsStatsHeaderProps> = ({
  summary,
  isLoading,
}) => {
  const { t } = useTranslation();

  const formatCount = (value: number | undefined) => {
    if (isLoading && value === undefined) {
      return <Loader color="gray" size="sm" type="dots" />;
    }
    if (value === undefined) {
      return '—';
    }
    return value.toLocaleString('fr-FR');
  };

  return (
    <div className={classes.statsBox}>
      <div className={classes.statBlock}>
        <Text className={classes.statValue} component="div">
          {formatCount(summary?.total)}
        </Text>
        <Text className={classes.statLabel}>
          {t('sampling.results.stats.total_label')}
        </Text>
      </div>
      {GES_STATUS_STAT_ORDER.map((status) => {
        const meta = getGesStatusMeta(status);
        const count = getGesStatusCount(summary, status);

        return (
          <div className={classes.statBlock} key={status}>
            <Group gap={6} justify="center" wrap="nowrap">
              {meta ? (
                <IconCircleFilled color={meta.hexColor} size={14} />
              ) : null}
              <Text className={classes.statValue} component="div">
                {formatCount(count)}
              </Text>
            </Group>
            <Text className={classes.statLabel}>
              {t(`sampling.results.stats.ges_${status}`)}
            </Text>
          </div>
        );
      })}
    </div>
  );
};

